import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'dp-shipment-bing-maps-dialog',
  templateUrl: './shipment-bing-maps-dialog.component.html',
  styleUrls: ['./shipment-bing-maps-dialog.component.scss'],
})
export class ShipmentBingMapsDialogComponent {
  shipmentDetail;
  trackingType;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.shipmentDetail = data.shipmentDetail;
    this.trackingType = data.trackingType;
  }
}
